<template>
  <div class="tab-container">
    Products
  </div>
</template>

<script >
import { getClimbingGroupsEquipmentItems } from '@/http'

export default {
  name: 'ClimbingGroupsSupplyDetailProducts',
}
</script>

